/* @generated */

// ../src/badge/badge.tsx
import * as React3 from "react";

// ../src/_global/components/internal_box.tsx
import * as React from "react";
import { Box } from "@dropbox/dig-foundations";
var InternalBox = ({
  children,
  className: _cls,
  _dangerouslySetClassName,
  sx,
  ...rest
}) => {
  return (
    // For now we pass through `sx` as it doesn't exist on `Box` yet, but an optimization to this will come soon, which will add this prop...
    /* @__PURE__ */ React.createElement(Box, { ...sx, ...rest, className: _dangerouslySetClassName }, children)
  );
};

// ../src/badge/badge_icon.tsx
import * as React2 from "react";
import clsx from "classnames";

// ../src/badge/index.css.ts
import { createRuntimeFn as _7a468 } from "@vanilla-extract/recipes/createRuntimeFn";
var badge = _7a468({ defaultClassName: "dig-5032no1_20-11-1", variantClassNames: { variant: { alert: "dig-5032no2_20-11-1", standard: "dig-5032no3_20-11-1", success: "dig-5032no4_20-11-1", attention: "dig-5032no5_20-11-1", warning: "dig-5032no6_20-11-1" }, size: { xsmall: "dig-5032no7_20-11-1", small: "dig-5032no8_20-11-1" }, hasNoChildren: { true: "dig-5032no9_20-11-1", false: "dig-5032noa_20-11-1" }, over: { subtle: "dig-5032nob_20-11-1", base: "dig-5032noc_20-11-1" } }, defaultVariants: { over: "base", variant: "standard", hasNoChildren: false }, compoundVariants: [] });
var badgeIcon = "dig-5032noh_20-11-1";
var badgeIconSizing = { xsmall: "dig-5032noi_20-11-1", small: "dig-5032noj_20-11-1" };
var badgeNoChildren = "dig-5032nof_20-11-1";
var badgeSizing = { xsmall: "dig-5032nod_20-11-1", small: "dig-5032noe_20-11-1" };
var badgeWithIconEnd = "dig-5032nog_20-11-1";

// ../src/badge/badge_icon.tsx
function getNegatedMargin(size) {
  switch (size) {
    case "xsmall":
      return -2;
    case "small":
      return -3;
  }
}
var Icon = ({ src: SrcIcon, size }) => {
  const cls = clsx("dig-Badge-Icon", `${badgeIcon}`, `${badgeIconSizing[size]}`, {
    [`dig-Badge-Icon--${size}`]: size
  });
  const style = {
    marginLeft: getNegatedMargin(size),
    marginRight: getNegatedMargin(size)
  };
  return /* @__PURE__ */ React2.createElement("span", { className: cls }, /* @__PURE__ */ React2.createElement("span", { style, "aria-hidden": "true" }, /* @__PURE__ */ React2.createElement(SrcIcon, null)));
};

// ../src/badge/badge.tsx
import clsx2 from "classnames";
var Badge = ({
  children,
  className,
  variant = "standard",
  size = "xsmall",
  withIconEnd: IconEnd,
  over,
  ...rest
}) => {
  const hasNoChildren = !children && typeof children !== "number" && !IconEnd;
  const cls = clsx2(
    "dig-Badge",
    className,
    badge({ variant, over, size, hasNoChildren }),
    `${badgeSizing[size]}`,
    {
      [`dig-Badge--${variant}`]: variant,
      [`dig-Badge--${size}`]: size,
      [`dig-Badge--with-icon-end`]: IconEnd,
      [`${badgeWithIconEnd}`]: IconEnd,
      [`dig-Badge--over-${over}`]: over,
      "dig-Badge--no-children": hasNoChildren,
      [`${badgeNoChildren}`]: hasNoChildren
    }
  );
  return /* @__PURE__ */ React3.createElement("span", { ...rest, className: cls }, /* @__PURE__ */ React3.createElement(InternalBox, { as: "span", sx: { display: "inline-flex", alignItems: "center" } }, !hasNoChildren && children), IconEnd && /* @__PURE__ */ React3.createElement(Icon, { src: IconEnd, size }));
};
Badge.displayName = "Badge";
export {
  Badge
};
